import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor(private http: HttpClient) { }

  saveTime(data) {
    return this.http.put(
      `${environment.apiHost}/v1/time`,
      data
    );
  }

  updateTime(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/time`,
      data
    );
  }

  get(data) {
    return this.http.post(
      `${environment.apiHost}/v1/time`,
      data
    );
  }

  getPendingCheck() {
    return this.http.get(
      `${environment.apiHost}/v1/time/pending-check`
    );
  }

  getPendingApprove() {
    return this.http.get(
      `${environment.apiHost}/v1/time/pending-approve`
    );
  }

  updateStatus(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/time/update-status`,
      data
    );
  }

  getUsers(data) {
    return this.http.post(
      `${environment.apiHost}/v1/personal-registration`,
      data
    );
  }

  getWork(data) {
    return this.http.post(
      `${environment.apiHost}/v1/work-order`,
      data
    );
  }
}
